"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagAG = function FlagAG(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-107.87l9,46.78,26.18-39.8L37.3-54.23,76.71-81,50-41.57,96.62-51.2,56.82-25l46.78,9-46.78,9,39.8,26.17L50,9.43,76.71,48.85,37.3,22.1l9.63,46.65L20.75,29,11.8,75.74,2.84,29l-26.17,39.8L-13.7,22.1-53.12,48.85-26.37,9.43-73,19.06l39.8-26.17-46.79-9L-33.22-25-73-51.2l46.65,9.63L-53.12-81-13.7-54.23l-9.63-46.66L2.84-61.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193-114.94V139.3a7.06,7.06,0,0,0,7.06,7.06H11.8l-203-266a7,7,0,0,0-1.84,4.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,146.36H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7,7,0,0,0-1.84-4.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69,40.43H92.64l43.12-56.5H-112.16Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-69,40.43,11.8,146.36,92.64,40.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagAG;
exports["default"] = _default;